import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';
import { Language } from '../../models/language';
import { MatIconRegistry } from '@angular/material/icon';
import { MatMenuTrigger } from '@angular/material/menu';
import { DomSanitizer } from '@angular/platform-browser';
import { throttleTime } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';
import { WINDOW } from '../../../shared/services/window.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class HeaderComponent implements OnInit, OnDestroy {
    @Input()
    isLoggedIn: boolean;
    @Input()
    hasNonEmptyQuotes: boolean;
    @Input()
    currentLanguage: Language;
    @Input()
    languages: Language[];
    @Output()
    languageSwitched = new EventEmitter<Language>();
    @Output()
    loggedOut = new EventEmitter();
    @Output()
    openQuoteViewSelection = new EventEmitter();
    @Output()
    openSiteMenu = new EventEmitter();

    private readonly iconsToRegister =
        [
            "burger-menu", "language-german", "language-english", "account",
            "quote-list-empty", "quote-list", "search"
        ]
    readonly routes = [
        {
            name: $localize`:@@site-menu_entry-categories:Home`,
            path: '/home'
        },
        {
            name: $localize`:@@site-menu_entry-catalog:Catalog`,
            path: '/products'
        },
        {
            name: $localize`:@@site-menu_entry-downloads:Downloads`,
            path: '/download'
        },
        {
            name: $localize`:@@site-menu_entry-contact:Contact`,
            path: '/contact'
        },
    ];

    @ViewChildren(MatMenuTrigger) menuTriggers: QueryList<MatMenuTrigger>;
    private onWindowResize$: Subscription;

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private location: Location,
        @Inject(WINDOW) private window: Window
    ) {

        this.iconsToRegister.forEach(icon_name => {
            this.matIconRegistry.addSvgIcon(
                `hering-${icon_name}`,
                this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/images/header/${icon_name}.svg`))
        })

        this.matIconRegistry.addSvgIcon(
            'hering-logo',
            this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/hering-logo.svg')
        );
    }

    logout() {
        this.loggedOut.emit();
    }

    get path() {
        return this.location.path();
    }

    switchLanguage(language: Language) {
        this.languageSwitched.emit(language);
    }

    onOpenQuoteList() {
        this.openQuoteViewSelection.emit();
    }

    onOpenSiteMenu() {
        this.openSiteMenu.emit();
    }

    ngOnInit(): void {
        this.onWindowResize$ = fromEvent(this.window, 'resize')
            .pipe(throttleTime(2000))
            .subscribe((e: Event) => {
                this.menuTriggers.forEach(menuTrigger => menuTrigger.closeMenu());
            });
    }

    ngOnDestroy(): void {
        this.onWindowResize$.unsubscribe();
    }
}
